import { render, staticRenderFns } from "./FilterSinisters.vue?vue&type=template&id=f60f4414&scoped=true"
import script from "./FilterSinisters.vue?vue&type=script&lang=js"
export * from "./FilterSinisters.vue?vue&type=script&lang=js"
import style0 from "./FilterSinisters.vue?vue&type=style&index=0&id=f60f4414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60f4414",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/FilterSinisters.vue
// module id = 704
// module chunks = 31